import React, { useEffect, useState } from 'react'
import { IFormElementProps, createSyntheticChangeEvent, useAutocompleteConfig } from '@cicero/ui/forms'
import { Autocomplete, makeStyles } from '@cicero/ui'
import { AttributeValueDoc, useModel } from 'models'
import { UserSchema } from '../models/UserSchema'
import { UserTile } from 'user'

interface IPageChooserProps extends IFormElementProps<UserSchema|null> {
  label?: string
  alwaysOpen?: boolean
  autoFocus?: boolean
  selectedValues?: AttributeValueDoc[]
}

export const UserChooser = ({ name, value, onChange, ...restOfParams }: IPageChooserProps) => {
  const Users = useModel(UserSchema)
  const [options, setOptions] = useState<UserSchema[]>([])

  useEffect(() => {
    const sub = Users.QUERY$({ selector: {} })
      .subscribe(users => {
        setOptions(users)
        // if (selectedValues && selectedValues.length) {

        // }
      })
    return () => sub.unsubscribe()
  }, [])

  return <Autocomplete
    {...useAutocompleteConfig(restOfParams)}
    value={value}
    options={options}
    getOptionLabel={(user: UserSchema) => user.first_name}
    onChange={(event, newVal) => {
      onChange(createSyntheticChangeEvent(name, newVal))
    }}
  />
}

export const UserListRenderer = ({ ids, size }: { ids: string[], size?: number }) => {
  const { userList } = useStyles()
  return ids.length ? <ul className={userList}>{
    ids.map((id, i) => <li key={i}>
      <UserTile id={id} size={size} noPad={size && size < 32 ? true : false} />
    </li>)
  }</ul> : null
}

const useStyles = makeStyles({
  userList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
})
